import request from '@/utils/request'

let Ml_directoryApi = {
    getJzList(data) {
        return request._post('/shop/plus.ml_directory.Index/getDatefl', data);
    },

  /*目录列表*/
  list(data) {
    return request._post('/shop/plus.ml_directory.Index/index', data);
},
/*添加目录*/
add(data) {
    return request._post('/shop/plus.ml_directory.Index/add', data);
},
/*修改目录*/
edit(data) {
    return request._post('/shop/plus.ml_directory.Index/edit', data);
},
/*删除目录*/
del(data) {
    return request._post('/shop/plus.ml_directory.Index/del', data);
},
/*目录详情*/
detail(data) {
  return request._post('/shop/plus.ml_directory.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ml_directory.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ml_directory.Setting/getSetting', data, errorback);
    },
}
export default Ml_directoryApi;



// WEBPACK FOOTER //
// ./src/api/ml_directory.js